import React, { Suspense } from "react";
import { LoadingSpinner } from "src/components/ui/loading-spinner";

const CloudWatchIntegration = React.lazy(() => import("./CloudWatchIntegration"));

interface CloudWatchIntegrationLazyProps {
  isOpen: boolean;
  onClose: () => void;
  onRefetch?: () => void;
  brandTheme?: string | null;
}

export default function CloudWatchIntegrationLazy(props: CloudWatchIntegrationLazyProps) {
  return (
    <Suspense fallback={<div className="flex justify-center p-4"><LoadingSpinner /></div>}>
      <CloudWatchIntegration {...props} />
    </Suspense>
  );
}
